// Almacenes que se pueden asociar a una venta desde el modal de reserva.
// La lista esta fija (hardcodeada) por pedido del negocio; cuando exista un
// endpoint de almacenes, este modulo es el unico punto a reemplazar.
// El valor guardado es la etiqueta completa porque hay tres sedes "La molina"
// y dos "Puente piedra": el numero de almacen es lo unico que las distingue.
export const ALMACENES_VENTA = [
    'Almacen 1 - ATE- AV. INDUSTRIAL',
    'Almacen 2 - Surquillo',
    'Almacen 3 - San juan de miraflores',
    'Almacen 4 - Ate o Gambeta',
    'Almacen 5 - Salamanca',
    'Almacen 6 - Puente piedra',
    'Almacen 7 - La molina',
    'Almacen 8- La molina',
    'Almacen 9- La molina',
    'Almacen 10 - SMP',
    'Almacen 11- Puente piedra',
    'Almacen 12- smp',
    'Almacen 13- Ventanilla.'
]

/**
 * Normaliza los atributos que vienen de la venta: algunas filas viejas los
 * guardan como string JSON, y no queremos perder ese contenido al escribir el
 * almacen.
 */
function atributosComoObjeto(atributos) {
    if (typeof atributos === 'string') {
        try {
            const parsed = JSON.parse(atributos)
            return parsed && typeof parsed === 'object' ? parsed : {}
        } catch (error) {
            return {}
        }
    }
    return atributos && typeof atributos === 'object' ? atributos : {}
}

/**
 * Copia los atributos de la venta agregando el almacen seleccionado.
 * El almacen viaja dentro de `atributos` (JSON de la venta) y no en una columna
 * propia; el resto de los atributos se conserva tal cual.
 */
export function conAlmacen(atributos, almacen) {
    return { ...atributosComoObjeto(atributos), almacen: almacen ? almacen : null }
}
